/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
  Paper,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import Loading from '../Loading';
import api from '../../utils/functions/api';
import SCB from '../../assets/images/SCB.png';
// import KBANK from '../../assets/images/KBANK.png';

const MobileBankingPopup = ({
  open,
  onClose,
  tokens,
  etaxData,
  payType,
  language,
  bank,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSelectOption = (option) => {
    console.log('option', option);
    setSelectedOption(option);
  };

  useEffect(() => {
    if (bank === '') {
      handleSelectOption('SCB'); // เลือกตัวเลือกที่เหลือเพียงอันเดียว
    }
  }, [bank]); // ทำงานเมื่อ bank เปลี่ยนแปลง

  const urlOPS = useRef('');
  const formOPS = useRef('');

  const handlePaymentClick = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/createpayment`,
        {
          source: `DL ${selectedOption} ${etaxData?.branchCode ?? ''} ${
            etaxData?.tax ?? ''
          } ${etaxData?.postalCode ?? ''}`,
          eTaxData: {
            BUYER_NAME: etaxData?.name,
            BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
            BUYER_TAX_ID: etaxData?.taxId,
            BUYER_BRANCH_ID: etaxData?.branchCode,
            BUYER_POST_CODE: etaxData?.postalCode,
            BUYER_ADDRESS_LINE1: etaxData?.address,
            BUYER_ADDRESS_LINE2: etaxData?.address2,
          },
          etaxname: etaxData?.etaxname ?? '',
          etaxaddress1: etaxData?.etaxaddress1 ?? '',
          etaxaddress2: etaxData?.etaxaddress2 ?? '',
          email: etaxData?.email ?? '',
          term: payType === 'IN' ? etaxData?.term : null,
          card_id: etaxData?.select_card?.card_id ?? '',
        },
        { headers: { Authorization: tokens } },
      );
      setIsLoading(false);
      if (data.status === 'paid' && data.company_callback) {
        navigate(
          `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'paid' && !data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && !data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'cancel' && !data.company_callback) {
        navigate(
          `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else {
        window.location.replace(data.paymentURL);
        urlOPS.current = data.paymentToken;
        formOPS.current = data.paymentURL;
        setTimeout(() => {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = urlOPS.current;
          form.innerHTML = formOPS.current;
          document.body.appendChild(form);
          form.submit();
        }, 750);
      }
    } catch (error) {
      console.error('Error processing payment:', error);
    }
  };

  const paymentOptions = [
    {
      label: 'SCB',
      icon: (
        <img
          src={SCB}
          alt="SCB"
          style={{
            width: 'auto',
            marginTop: '2px',
            marginBottom: '2px',
          }}
        />
      ),
    },
    // {
    //   label: 'KBANK',
    //   icon: (
    //     <img
    //       src={KBANK}
    //       alt="KBANK"
    //       style={{
    //         width: 'auto',
    //         marginTop: '2px',
    //         marginBottom: '2px',
    //       }}
    //     />
    //   ),
    // },
    // เพิ่มช่องทางอื่น ๆ ในอนาคตที่นี่
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '900px',
        },
      }}
    >
      <Loading isLoading={isLoading} />
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginTop: '20px',
            marginLeft: '20px',
          }}
        >
          {language === 'TH'
            ? 'เลือกธนาคารเพื่อชำระเงิน'
            : 'Select a bank for payment'}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            marginTop: '20px',
            marginBottom: '20px',
            marginLeft: '20px',
            marginRight: '20px',
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {paymentOptions.map((option, index) => (
              <Grid item xs={6} md={4} key={index}>
                <Paper
                  elevation={3}
                  sx={{
                    padding: { xs: '15px', md: '25px' },
                    textAlign: 'center',
                    borderRadius: '15px',
                    cursor: bank?.includes(option.label)
                      ? 'pointer'
                      : 'not-allowed',
                    border:
                      selectedOption === option.label
                        ? '2px solid #0288d1'
                        : 'none',
                    // opacity: bank?.includes(option.label) ? 1 : 0.5, // ลดความชัดเจนของตัวเลือกที่ไม่ได้เปิดใช้งาน
                  }}
                  onClick={() =>
                    // bank?.includes(option.label) &&
                    handleSelectOption(option.label)
                  } // อนุญาตให้คลิกได้เฉพาะที่อยู่ใน bank array
                >
                  {option.icon}
                  <Typography
                    variant="subtitle1"
                    component="div"
                    fontWeight="bold"
                  ></Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            marginBottom: '40px',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              width: '100px', // Adjust the width as needed
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
          </Button>
          <Button
            onClick={handlePaymentClick}
            disabled={!selectedOption} // ปุ่มจะถูกปิดใช้งานถ้าไม่มีการเลือกช่องทางการชำระเงิน
            sx={{
              width: '100px', // Adjust the width as needed
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default MobileBankingPopup;
